import UltMeta, { Meta } from "./UltMeta/index";
// 客户定义

class Role extends UltMeta {
    CUSTOMER = new Meta(1, "采购商");
    SUPPLIER = new Meta(2, "供应商");
    SUPPLY_CHAIN = new Meta(3, "联合购销商");
    CARRIER = new Meta(4, "承运商");
}
export const ROLE = new Role();

/** TODO: 3826 查船迁移兼容：关注视角弹窗注册来源，待 supplier-web 客户来源字典确认后替换。 */
class RegisterSource extends UltMeta {
    UNKNOWN = new Meta("", "--");
}

export const REGISTER_SOURCE = new RegisterSource();

// 子账号权限
class Permission extends UltMeta {
    // 进销存角色 1-10,17
    CONTRACT = new Meta(1, "进销存合同专员");
    PAYMENT = new Meta(2, "进销存资金专员");
    FREIGHT = new Meta(3, "进销存订单专员");
    SHIPMENT = new Meta(17, "进销存发货专员");
    SIGNATURE = new Meta(4, "进销存签收专员");
    RECONCILIATION = new Meta(5, "进销存结算专员");
    INVOICE = new Meta(6, "进销存开票专员");
    FINANCING = new Meta(7, "进销存融资专员");
    INBOUND = new Meta(21, "进销存入库专员");
    OUTBOUND = new Meta(9, "进销存出库专员");
    SAMPLING = new Meta(10, "进销存抽检专员");
    INVENTORY = new Meta(8, "进销存盘点专员");
    PLEDGE = new Meta(22, "进销存质押专员");
    REPORT = new Meta(24, "进销存报表专员");
    WAREHOUSE = new Meta(28, "进销存仓库专员");
    STORAGE_INCEPTION = new Meta(23, "进销存仓储期初专员");

    // 仓储业务角色 11-16
    STOCK_CONTRACT = new Meta(11, "仓储业务合同专员");
    STOCK_OUTBOUND = new Meta(12, "仓储业务出库专员");
    STOCK_INBOUND = new Meta(13, "仓储业务入库专员");
    TRANSFER = new Meta(14, "仓储业务过户专员");
    STOCK_SAMPLING = new Meta(15, "仓储业务抽检专员");
    STOCK_INVENTORY = new Meta(16, "仓储业务盘点专员");

    // 仓储管理角色
    STORE_CONTRACT = new Meta(18, "仓储管理合同专员");
    STORE_OUTBOUND = new Meta(19, "仓储管理出库专员");
    STORE_INBOUND = new Meta(20, "仓储管理入库专员");

    // 风控管理
    RISK_CONTROL = new Meta(25, "风控管理");

    // 贸易业务
    TRADE_CONTRACT = new Meta(26, "贸易业务合同专员");
    TRADE_RECONCILIATION = new Meta(27, "贸易业务结算专员");

    // 其他权限
    REGULAR_CUSTOMERS = new Meta(29, "往来客户");
    REGULAR_SUPPLIERS = new Meta(30, "往来供应链");
    INVOICE_HEADER = new Meta(31, "发票抬头");
    ADDRESS = new Meta(32, "我的地址");
    BANK_ACCOUNT = new Meta(33, "银行账户");
}

export const PERMISSION = new Permission();

// 企业身份
class CustomerRoleType extends UltMeta {
    PURCHASE_CUSTOMER = new Meta(1, "采购客户");
    WAREHOUSE_CUSTOMER = new Meta(2, "仓储业务客户");
    WAREHOUSE_MANAGE_CUSTOMER = new Meta(5, "仓储管理客户");
}

export const CUSTOMER_ROLE_TYPE = new CustomerRoleType();

/**
 * 客户当前账户认证状态。
 */
class CustomerState extends UltMeta {
    UNREGISTERED = new Meta(0, "未实名");
    PERSONAUTH = new Meta(1, "完成个人认证");
    SYSENTERPRISEAUTH = new Meta(2, "完成个人认证，系统内企业认证");
    ENTERPRISEAUTH = new Meta(3, "完成个人认证，系统内企业认证，契约锁企业认证");
    CORPORATEAUTH = new Meta(4, "完成个人认证，系统内企业认证，契约锁企业认证，企业授权");
}
export const CUSTOMER_PHONE_STATE = new CustomerState();

/**
 * 客户手机号换绑入口状态。
 */
class ChangeMobileState extends UltMeta {
    NO = new Meta(0, "当前状态不能换绑");
    YES = new Meta(1, "当前状态可以换绑");
    PROCESSING = new Meta(2, "换绑中");
}
export const CHANGE_MOBILE_STATE = new ChangeMobileState();
